// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2bxsd","unreadBadge":"styles_unreadBadge__ZGx7H","modalContent":"styles_modalContent__3zOO2","modal":"styles_modal__1LG0L"};